import { createContext } from 'react'

// eslint-disable-next-line no-sparse-arrays
const Context = createContext<[void, any]>([, {}])

export default Context
